/* ==========================================================================
   PLAYNOSTALGIA — pn-product.js
   Galerie (slider tactile + miniatures + zoom), variantes, sticky ATC.
   Les valeurs d'option incompatibles avec la sélection sont masquées.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Galerie ---------- */
  function initGallery(root) {
    var slidesWrap = root.querySelector('[data-pn-gallery-slides]');
    if (!slidesWrap) return;

    var slides = root.querySelectorAll('[data-pn-gallery-slide]');
    var thumbs = root.querySelectorAll('[data-pn-gallery-thumb]');
    var dots = root.querySelectorAll('[data-pn-gallery-dot]');

    function setActive(index) {
      Array.prototype.forEach.call(thumbs, function (t, i) {
        t.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      Array.prototype.forEach.call(dots, function (d, i) {
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function goTo(index) {
      var slide = slides[index];
      if (!slide) return;
      slidesWrap.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      setActive(index);
    }

    root.pnGoTo = goTo;

    Array.prototype.forEach.call(thumbs, function (thumb, i) {
      thumb.addEventListener('click', function () {
        goTo(i);
      });
    });

    Array.prototype.forEach.call(dots, function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
      });
    });

    var scrollTimer;
    slidesWrap.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          var index = Math.round(slidesWrap.scrollLeft / slidesWrap.clientWidth);
          setActive(index);
        }, 90);
      },
      { passive: true }
    );

    /* Zoom au clic, suivi de la souris */
    Array.prototype.forEach.call(slides, function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;

      slide.addEventListener('click', function (e) {
        var zoomed = slide.classList.toggle('pn-is-zoomed');
        if (zoomed) {
          var rect = slide.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = x + '% ' + y + '%';
        } else {
          img.style.transformOrigin = 'center center';
        }
      });

      slide.addEventListener('mousemove', function (e) {
        if (!slide.classList.contains('pn-is-zoomed')) return;
        var rect = slide.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });

      slide.addEventListener('mouseleave', function () {
        slide.classList.remove('pn-is-zoomed');
        img.style.transformOrigin = 'center center';
      });
    });

    setActive(0);
  }

  /* ---------- Variantes ---------- */
  function initVariants(root) {
    var dataEl = root.querySelector('[data-pn-variants]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var idInput = root.querySelector('[data-pn-variant-id]');
    var priceEl = document.querySelector('[data-pn-price]');
    var compareEl = document.querySelector('[data-pn-compare]');
    var saveEl = document.querySelector('[data-pn-save]');
    var submitBtn = root.querySelector('[data-pn-submit]');
    var submitLabel = submitBtn ? submitBtn.querySelector('.pn-btn__label') : null;
    var stickyPrice = document.querySelector('[data-pn-sticky-price]');

    function selectedOptions() {
      var inputs = root.querySelectorAll('[data-pn-option]:checked, select[data-pn-option]');
      return Array.prototype.map.call(inputs, function (input) {
        return input.value;
      });
    }

    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < options.length; j++) {
          if (v.options[j] !== options[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    /* Masque les valeurs d'option incompatibles avec la sélection précédente */
    function refreshAvailability() {
      var groups = root.querySelectorAll('.pn-option');
      var chosen = selectedOptions();

      Array.prototype.forEach.call(groups, function (group, index) {
        var inputs = group.querySelectorAll('[data-pn-option]');
        var firstVisible = null;
        var currentValid = false;

        Array.prototype.forEach.call(inputs, function (input) {
          var test = chosen.slice();
          test[index] = input.value;

          var exists = variants.some(function (v) {
            for (var i = 0; i <= index; i++) {
              if (v.options[i] !== test[i]) return false;
            }
            return true;
          });

          var label = group.querySelector('label[for="' + input.id + '"]');
          input.disabled = !exists;
          if (label) label.hidden = !exists;

          if (exists) {
            if (!firstVisible) firstVisible = input;
            if (input.checked) currentValid = true;
          }
        });

        /* Si la valeur cochée n'est plus disponible, on bascule sur la première valide */
        if (!currentValid && firstVisible) {
          firstVisible.checked = true;
          chosen = selectedOptions();
        }
      });
    }

    function update() {
      refreshAvailability();
      var variant = findVariant(selectedOptions());

      if (!variant) {
        if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
        if (submitLabel) submitLabel.textContent = 'Indisponible';
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl && window.PN && window.PN.money) {
        priceEl.innerHTML = window.PN.money(variant.price);
      }
      if (stickyPrice && window.PN && window.PN.money) {
        stickyPrice.innerHTML = window.PN.money(variant.price);
      }

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.innerHTML = window.PN.money(variant.compare_at_price);
          compareEl.hidden = false;
          if (saveEl) {
            var pct = Math.round(
              ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
            );
            saveEl.textContent = '-' + pct + '%';
            saveEl.hidden = false;
          }
        } else {
          compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
      }

      if (submitBtn) {
        if (variant.available) {
          submitBtn.removeAttribute('disabled');
          if (submitLabel) {
            submitLabel.textContent =
              submitBtn.getAttribute('data-label-default') || 'Ajouter au panier';
          }
        } else {
          submitBtn.setAttribute('disabled', 'disabled');
          if (submitLabel) submitLabel.textContent = 'Rupture de stock';
        }
      }

      /* Défilement de la galerie vers l'image de la variante */
      var gallery = document.querySelector('[data-pn-gallery]');
      var pos = variant.featured_media_position;
      if (pos !== null && pos !== undefined && gallery && typeof gallery.pnGoTo === 'function') {
        gallery.pnGoTo(pos);
      }

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-pn-option]')) update();
    });

    update();
  }

  /* ---------- Barre d'achat mobile ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-pn-sticky-atc]');
    var anchor = document.querySelector('[data-pn-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        bar.classList.toggle('pn-is-visible', !entries[0].isIntersecting);
      },
      { rootMargin: '0px 0px -100px 0px' }
    );

    observer.observe(anchor);
  }

  function init() {
    /* La galerie est initialisée EN PREMIER : initVariants dépend de pnGoTo. */
    var gallery = document.querySelector('[data-pn-gallery]');
    if (gallery) initGallery(gallery);

    var form = document.getElementById('pn-product-form');
    if (form) initVariants(form);

    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();